import React from 'react';
import { t } from '@cyberint/common-utils';
import { Themes } from '@cyberint/dsc';
import * as S from './styled';

export const ReloadMessage = ({ message }) => (
  // const refresh = () => window.location.reload(); // not enough - need invoke infinity to reload ERM app
  <S.RefreshMsg data-testid="embedded-refresh" className={Themes.LIGHT}>
    <div>{message || t('common.refreshMsg')}</div>
    {/* <LinkedButton onClick={refresh}>{t('common.refresh')}</LinkedButton> */}
  </S.RefreshMsg>
);
